export default "__VITE_ASSET__9842053d__"